// section-hero-carousel.js — <hero-carousel> Web Component, ~3KB
class HeroCarousel extends HTMLElement {
  constructor() {
    super();
    this.index = 0;
    this.timer = null;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  connectedCallback() {
    this.track = this.querySelector('.hero__track');
    this.slides = Array.from(this.querySelectorAll('.hero__slide'));
    this.dots = Array.from(this.querySelectorAll('.hero__dots button'));
    this.live = this.querySelector('.hero__live');
    this.prevBtn = this.querySelector('.hero__arrow--prev');
    this.nextBtn = this.querySelector('.hero__arrow--next');

    this.total = this.slides.length;
    if (this.total === 0) return;

    this.autoplay = this.dataset.autoplay !== 'false' && !this.reduced;
    this.interval = parseInt(this.dataset.interval, 10) || 5000;

    this.go(0); // show first slide immediately on load

    if (this.total <= 1) return;
    this._bindEvents();
    this._startAutoplay();
  }

  disconnectedCallback() { this._stopAutoplay(); }

  _bindEvents() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.go(this.index - 1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.go(this.index + 1));
    this.dots.forEach(d => d.addEventListener('click', () => this.go(parseInt(d.dataset.index, 10))));

    this.addEventListener('mouseenter', () => this._stopAutoplay());
    this.addEventListener('mouseleave', () => this._startAutoplay());
    this.addEventListener('focusin', () => this._stopAutoplay());
    this.addEventListener('focusout', () => this._startAutoplay());

    // Keyboard
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); this.go(this.index - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); this.go(this.index + 1); }
      if (e.key === 'Home')       { e.preventDefault(); this.go(0); }
      if (e.key === 'End')        { e.preventDefault(); this.go(this.total - 1); }
    });

    // Touch swipe
    let startX = 0;
    this.addEventListener('pointerdown', (e) => { startX = e.clientX; });
    this.addEventListener('pointerup', (e) => {
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 40) this.go(this.index + (dx < 0 ? 1 : -1));
    });
  }

  // No per-slide height. --hero-ratio is set once by hero-carousel.liquid from
  // the shape most of the slides share, and nothing here touches it: resizing
  // the hero on every advance pushed the rest of the page up and down and read
  // as a glitch.
  go(i) {
    const next = ((i % this.total) + this.total) % this.total;
    this.index = next;
    this.slides.forEach((s, idx) => {
      const active = idx === next;
      s.setAttribute('data-active', String(active));
      s.classList.toggle('is-active', active);
      s.setAttribute('aria-hidden', String(!active));
      const link = s.querySelector('.hero__link');
      if (link) link.tabIndex = active ? 0 : -1;
    });
    this.dots.forEach((d, idx) => {
      const active = idx === next;
      d.setAttribute('aria-selected', String(active));
      d.tabIndex = active ? 0 : -1;
    });
    if (this.live) this.live.textContent = `Slide ${next + 1} of ${this.total}`;
    this._restartAutoplay();
  }

  _startAutoplay() {
    if (!this.autoplay || this.timer) return;
    this.timer = setInterval(() => this.go(this.index + 1), this.interval);
  }
  _stopAutoplay() {
    if (this.timer) { clearInterval(this.timer); this.timer = null; }
  }
  _restartAutoplay() { this._stopAutoplay(); this._startAutoplay(); }
}

customElements.define('hero-carousel', HeroCarousel);
